<!-- <div class="container">
<div class="print-hide notification" *ngIf="notification && showNotification"
  (click)="showNotification = false">
  <mat-icon>close</mat-icon>
  <p i18n="@@errorNotificationMassege"> לצערנו התרחשה שגיאה בקבלה או הצגה של נתונים </p>
</div>
</div> -->

@if (showLiveNotification() && liveNotificationComponent(); as liveNotification) {
    <section class="print-hide">
        <ng-container *ngComponentOutlet="liveNotification"></ng-container>
    </section>
}
<section class="main-container">
    @if (showTopUserSummary() && userSummaryComponent(); as userSummary) {
        <ng-container *ngComponentOutlet="userSummary"></ng-container>
    }
</section>

<main id="main-content">
    <router-outlet></router-outlet>
</main>
@if (showBottomUserSummary() && userSummaryComponent(); as userSummary) {
    <section class="print-hide main-container">
        <ng-container *ngComponentOutlet="userSummary"></ng-container>
    </section>
}
